import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_wrkrs_free_to_come_and_go_from_the_dormitories_and_the_indu'

export const dataPointDefinition = {
  retracedId: 'are_wrkrs_free_to_come_and_go_from_the_dormitories_and_the_indu',
  name: 'Are workers free to come and go from the dormitories and the industrial park or zone in which the facility is located?',
  description:
    "If workers cannot freely leave the dormitories or industrial zone at all times, this may be an indication of forced labor. This applies to all workers, including local workers, as well as migrant and refugee workers.\r\r\n\r\r\nAnswer No if management has put strong controls in place to restrict workers' movement, such as locked dormitories, an enforced curfew (e.g., management approval required in order to leave), security guards, or other coercive measures. Also consider the extent to which workers' freedom is restricted, including whether workers can leave the dorms and industrial park after they finish work (including overtime), and on their days off. \r\r\n\r\r\nAlso consider the vulnerability of the workers, including whether they have no real choice but to live in the dorms due to lack of choice or feasible alternatives. If management uses strong controls that significantly restrict workers' freedom to leave the dormitories or industrial zone, and workers do not have feasible alternatives to the dorm housing, answer No.",
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wt-for-5',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 10020,
  sectionId: '2.2.7',
  impactArea: 'Forced Labour',
  impactAreaId: 'FORCED_LABOUR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
